$(function(){
  // navbar
  $(".navbar-toggler").on('click',function(){
    $(".menu1").toggleClass("menuclick1");
    $(".menu2").toggleClass("menuclick2");
    $(".menu3").toggleClass("menuclick3");
  });

  // スマホメニュー外部クリックで非表示
  $('.navbar-nav').click(function(){
    $('#navbars').removeClass('show');
  });

  //toTopの表示・非表示
  function displayToTop(){
    var scrollTop = $(window).scrollTop();
    if (scrollTop < 300) {
      $(".to-page-top").fadeOut();
    } else {
      $(".to-page-top").fadeIn();
      $(".to-page-top a").smoothScroll({offset: -80});
    }
  }
  $(window).on("load scroll", displayToTop);

  // 目的から探す
  $('#floating-nav').on('click',function(){
    $(this).parent('#floating').toggleClass('open');
  });

  // スマホ以外電話リンクOFF
  var ua = navigator.userAgent.toLowerCase();
  var isMobile = /iphone/.test(ua)||/android(.+)?mobile/.test(ua);
  if (!isMobile) {
      $('a[href^="tel:"]').on('click', function(e) {
          e.preventDefault();
      }).addClass('disable');
  }

   $('#menu .menu, a.btn, #navbar a').on('touchstart', function(){
     $(this).addClass('hover');
   }).on('touchend', function(){
     $(this).removeClass('hover');
   });

  //home
  if ($('body').hasClass('home')) {
    $('.slider').slick({
      centerMode: true,
      arrow: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 3000,
      infinite: true,
      variableWidth: true,
      pauseOnHover: false
    });
    $('.mag-slider').slick({
      // centerMode: true,
      arrow: false,
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 3000,
      infinite: true,
      centerPadding:0,
      pauseOnHover: false
    });
  }

});
$(window).on("load resize", function(){
  if ($(window).width()> 1024) {
    if ($('body').hasClass('home')) {
      var arrowPosition = ($(window).width()-685)/2 -8;
      $('.slider .slick-prev').css('left',arrowPosition+ 'px');
      $('.slider .slick-next').css('right',arrowPosition+ 'px');
      // console.log( $(window).width() +''+arrowPosition);
    }
  }
});

$(window).on("load resize", mainImage);
function mainImage(){
  if ($('body').hasClass('works-detail')) {
    var mainImageW = $('.asset-header img').width();
    var mainImageH = $('.asset-header img').height();
    var mainImageRatio = mainImageH / mainImageW;
    var windowWidth = $(window).width();
    var assetW = $('.asset-header').width();
    console.log(mainImageRatio +'　'+ mainImageW +'　'+ mainImageH +'　'+ windowWidth);
    if (windowWidth-assetW > 0) {
      $('.asset-header img').css({
        'left': -(windowWidth-assetW)/2+ 'px',
        'width':windowWidth+ 'px'
      });
    }
    $('.asset-header').css('paddingTop', windowWidth*mainImageRatio+20+ 'px');
  }
}
